export default function ChangeQuantityButton({quantity, handleChangeQuantity}) {
    return (
        <div className="flex flex-row items-center mx-4">
            <button className="text-xl cursor-pointer transition-colors flex items-center justify-center relative no-underline opacity-25 first:-top-2.5" onClick={() => handleChangeQuantity(-1)}>_</button>
            <span className="text-[#868686] mx-4">{quantity}</span>
            <button className="text-2xl cursor-pointer transition-colors flex items-center justify-center relative no-underline opacity-25 first:-top-2.5" onClick={() => handleChangeQuantity(1)}>+</button>
        </div>
    )
}